import React from "react";
import styles from "./dashboard/Styles";
import {
  GET_ONE,
  GET_LIST,
  UPDATE,
  SimpleForm,
  FunctionField,
  Responsive,
  SaveButton,
  showNotification
} from "react-admin";
import { connect } from "react-redux";
import { change, submit } from "redux-form";
import moment from "moment";
import styled from "styled-components";
import { withStyles } from "@material-ui/core/styles";
import dataProviderFactory from "../dataProvider";
import ChargesGrid from "../components/listCharges";

import {
  Card,
  Select,
  MenuItem,
  InputLabel,
  TextField,
  FormControlLabel,
  Switch,
  CardContent,
  Typography,
  LinearProgress,
  Paper,
  Checkbox,
  Grid,
  Button,
} from "@material-ui/core";

import { parse } from "query-string";

import {
  map,
  length,
  head,
  filter,
  prop,
  propEq,
  find,
  isNil,
  curry,
  sum,
  path,
} from "ramda";
import { isNull } from "util";
import * as R from "ramda";

//add suplement charge a rental price
import AddSuplementCharge from "../components/addSuplementCharge";
import { DATEFORMAT } from "../date-config";
import ProfileCompleteMark from "./profileCompleteMark";
import ClientDocumentsModal from "./ClientDocumentsModal";
import { documentTarget } from "../utils/agencyRiderDocuments";
import {
  applyLowSeasonDiscountFor,
  buildRentalPromoSnapshot,
  RENTAL_TIME_OPTIONS,
} from "../util/rentalPromo";
import { RentalPromoBadges } from "./RentalPromoBadges";
import {
  normalizeInsuranceId,
  resolveBookingInsuranceId,
  isPaidInsurance,
  resolveApplicableInsuranceId,
  insuranceLabel,
  insuranceSelectChoices,
  dailyInsurancePriceFromList,
  INSURANCE_REGULAR,
} from "../util/rentalInsurance";

const StyledSelect = styled(Select)`
  width: 256px !important;
`;

const StyledSpan = styled.div`
  color: red;
  padding: 10px;
  width: 100% !important;
`;
const StyledP = styled(FunctionField)`
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100% !important;
`;

let arrayVehicle = null, addSuplement = false, chargeSuplement = 0;

class ProcessRentalEdit extends React.Component {
  state = {
    invoice_comments: "",
    l: null,
    chargeId: 0,
    partial: 0,
    checkedF: false,
    isOnSubmit: false,
    discount: 0,
    driver_id: 0,
    refund_value: 0,
    comments: "",
    imt_commentN: "",
    imt_comment: "",
    extra_comments: "",
    chargeTypeId: "2",
    location_id_1: 0,
    location_id_2: 0,
    time_1: 0,
    time_2: 0,
    date_1: null,
    date_2: null,
    r_gps: false,
    rewards: 0,
    r_insurance: false,
    r_insurance_id: INSURANCE_REGULAR,
    low_seat: false,
    vehicle_model_1: 0,
    vehicle_model_2: 0,
    vehicleId: 0,
    gpsDeviceId: 0,
    rental: null,
    error: false,
    noEditEmail: false,
    chargesRental: [],
    chargeAvalaibleSuplement: 0,
    clientDocumentsModalOpen: false,
  };

  async getGpsDevices() {
    const { location_id_1, location_id_2, date_1, date_2, rental } = this.state;

    const selectedGpsDevice = head(rental.device) || { id: 0 };

    const dataProvider = await dataProviderFactory("rest");
    const responseGps = await dataProvider(GET_LIST, "gps_devices", {
      filter: {
        rental_id: rental.id,
        rental_availability: true,
        location_id_1,
        location_id_2,
        date_1,
        date_2
      },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });

    if (selectedGpsDevice.id === this.state.gpsDeviceId) {
      responseGps.data.push({
        id: selectedGpsDevice.id,
        model: selectedGpsDevice.model
      });
    }
    return responseGps;
  }

  async locationFeePrices(date) {
    const dataProvider = await dataProviderFactory("rest");
    const lcFreePrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        for_price_item_id: "rental_location_fee",
        location_id_1: this.state.location_id_1,
        location_id_2: this.state.location_id_2,
        for_date: date,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });
    return lcFreePrices;
  }

  async gpsPrices(date) {
    const dataProvider = await dataProviderFactory("rest");
    const gpsPrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        price_item_type: "gps_device",
        for_date: date,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });

    return gpsPrices;
  }

  async insurancePrices(date) {
    const dataProvider = await dataProviderFactory("rest");
    const insurancePrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        price_item_type: "insurance",
        for_date: date,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });
    return insurancePrices;
  }

  getVehicleModelPrices(modelPrices = [], days) {
    const matches = (modelPrices || []).filter(
      price =>
        Number(price.days_interval_1) <= days &&
        Number(price.days_interval_2) >= days
    );
    if (!matches.length) return 0;
    matches.sort((a, b) => {
      const da = a.start_date ? new Date(a.start_date).getTime() : 0;
      const db = b.start_date ? new Date(b.start_date).getTime() : 0;
      return db - da;
    });
    return prop("price", matches[0]) || 0;
  }

  async getModelPrices1(date) {
    return this.getModelPrices(this.state.vehicle_model_1, date);
  }

  async getModelPrices2(date) {
    return this.getModelPrices(this.state.vehicle_model_2, date);
  }

  async getModelPrices(model, date) {
    const dataProvider = await dataProviderFactory("rest");
    const modelPrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        prices_vehicle_model_id: model,
        for_date: date,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });
    return modelPrices;
  }

  async getHolidays1() {
    const { location_id_1 } = this.state;
    return this.getHolidays(location_id_1);
  }

  async getHolidays2() {
    const { location_id_2 } = this.state;
    return this.getHolidays(location_id_2);
  }

  async getHolidays(locationId) {
    const { date_1, date_2 } = this.state;

    const dataProvider = await dataProviderFactory("rest");
    const holidays = dataProvider(GET_LIST, "holidays", {
      filter: {
        startDate: date_1,
        endDate: date_2,
        location_id: locationId
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    return holidays;
  }

  async getVehicles(includeFirst, element) {
    const {
      rental,
      vehicle_model_1,
      location_id_1,
      location_id_2,
      date_1, vehicleId,
      date_2
    } = this.state;
    const selectedVehicle = head(rental.vehicle) || {};
    const dataProvider = await dataProviderFactory("rest");
    const responseVehicles = await dataProvider(GET_LIST, "vehicles", {
      filter: {
        selected_vehicle: includeFirst ? selectedVehicle.id : 0,
        rental_availability: true,
        rental_id: rental.id,
        vehicle_model_id: vehicle_model_1,
        vehicle_status_id: 1,
        location_id_1,
        location_id_2,
        date_1,
        date_2
      },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });

    const DisponibleBike = await dataProvider(GET_LIST, "vehicles", {
      filter: {
        selected_vehicle: includeFirst ? selectedVehicle.id : 0,
        Date_Availability: true,
        rental_id: rental.id, date_select: date_1, date2_select: date_2, // fecha seleccionanda para filtrar disponibilidad misma moto
        vehicle_model_id: vehicle_model_1, vehicleId: vehicleId,
        vehicle_status_id: 1,
        location_id_1,
        location_id_2,
        date_1,
        date_2
      },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });

    if (DisponibleBike.data.length === 0) {
      if (selectedVehicle.vehicle_model_id === this.state.vehicle_model_1) {
        responseVehicles.data.push({
          created_at: selectedVehicle.created_at,
          date_2: "",
          express_invoice_id: null,
          express_invoice_url: null,
          financing: 0,
          financing_details: "",
          id: selectedVehicle.id,
          insurance_date: null,
          insurance_policy: null,
          insurance_status_id: null,
          item_id: selectedVehicle.id,
          licence_plate: selectedVehicle.licence_plate,
          location_id_2: 0,
          location_name: 0,
          low: 0,
          number_rentals: 0,
          purchase_date: null,
          purchase_price: 0,
          purchased_from: 0,
          renting: 0,
          retirement_date: null,
          sale_date: null,
          sale_price: 0,
          sold_to: null,
          updated_at: selectedVehicle.updated_at,
          vechicle_chassis: selectedVehicle.vechicle_chassis,
          vehicle_color: selectedVehicle.vehicle_color,
          vehicle_mileage: selectedVehicle.vehicle_mileage,
          vehicle_model_id: selectedVehicle.vehicle_model_id,
          vehicle_options: selectedVehicle.vehicle_options,
          vehicle_status_id: selectedVehicle.vehicle_status_id,
          vehicle_year: selectedVehicle.vehicle_year
        });
      }
    }

    return responseVehicles;
  }

  async fetchData(id) {
    const dataProvider = await dataProviderFactory("rest");
    const responseRental = await dataProvider(GET_ONE, `rentals`, {
      id
    });

    const vehicleModels = await dataProvider(GET_LIST, "vehicle_models", {
      filter: { active: true, type: "2_2" },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });

    const responseLocations = await dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: "created_at", order: "DESC" }
    });

    const sameDay = this.isOnSameDay(responseRental.data.date_1, responseRental.data.date_2);
    let idvehicleN = 0;
    let licentPlate = '';
    let idModelVehicleN = 0
    if (R.isEmpty(responseRental.data.vehicle[0])
      || responseRental.data.vehicle[0] !== undefined) {
      idvehicleN = responseRental.data.vehicle[0].id
      idModelVehicleN = responseRental.data.vehicle[0].vehicle_model_id
      licentPlate = responseRental.data.vehicle[0].licence_plate
      arrayVehicle = {
        created_at: responseRental.data.vehicle[0].created_at,
        date_2: "",
        express_invoice_id: null,
        express_invoice_url: null,
        financing: 0,
        financing_details: "",
        id: responseRental.data.vehicle[0].id,
        insurance_date: null,
        insurance_policy: null,
        insurance_status_id: null,
        item_id: responseRental.data.vehicle[0].id,
        licence_plate: responseRental.data.vehicle[0].licence_plate,
        location_id_2: 0,
        location_name: 0,
        low: 0,
        number_rentals: 0,
        purchase_date: null,
        purchase_price: 0,
        purchased_from: 0,
        renting: 0,
        retirement_date: null,
        sale_date: null,
        sale_price: 0,
        sold_to: null,
        updated_at: responseRental.data.vehicle[0].updated_at,
        vechicle_chassis: responseRental.data.vehicle[0].vechicle_chassis,
        vehicle_color: responseRental.data.vehicle[0].vehicle_color,
        vehicle_mileage: responseRental.data.vehicle[0].vehicle_mileage,
        vehicle_model_id: responseRental.data.vehicle[0].vehicle_model_id,
        vehicle_options: responseRental.data.vehicle[0].vehicle_options,
        vehicle_status_id: responseRental.data.vehicle[0].vehicle_status_id,
        vehicle_year: responseRental.data.vehicle[0].vehicle_year
      }
    }
    let chargesRental = responseRental.data.payments
    let extraChargesPayed = 0
    const charges = prop("charges", head(responseRental.data.payments)); 
    for (let index = 0; index < charges.length; index++) {
        const element = charges[index];
        if(element.extra_charge === true && element.status == true)
        {  
          extraChargesPayed = extraChargesPayed + element.value
        } 
    }
    let suplementRemeaning = 0
    let chargeNotPayedSuplemento = charges.filter(function (c) {
      if (c.status == false && c.extra_charge == true) {
        return suplementRemeaning = suplementRemeaning + c.value;
      }
    })
   
    this.setState(
      {
        driver_id: responseRental.data.driver.id,
        rewards: responseRental.data.booking.rewards,
        vehicleId: idvehicleN,
        licence_plate: licentPlate,
        //vehicleId: responseRental.data.vehicle[0].id,
        //gpsDeviceId: prop("id", head(responseRental.data.device)) || 0,
        gpsDeviceId: responseRental.data.gps_device_id || 0,
        //vehicle_model_1: responseRental.data.booking.vehicle_model_1,
        vehicle_model_1: idModelVehicleN,
        //vehicle_model_1: responseRental.data.vehicle[0].vehicle_model_id,
        vehicle_model_2: responseRental.data.booking.vehicle_model_2,
        location_id_1: responseRental.data.location_id_1,
        location_id_2: responseRental.data.location_id_2,
        date_1: responseRental.data.date_1,
        date_2: responseRental.data.date_2,
        time_1: sameDay ? "10:00:00" : responseRental.data.time_1,
        time_2: sameDay ? "18:00:00" : responseRental.data.time_2,
        r_gps: responseRental.data.r_gps,
        r_insurance_id: (() => {
          const fromItem =
            responseRental.data.insurance &&
            responseRental.data.insurance[0] &&
            responseRental.data.insurance[0].id;
          if (fromItem != null) return normalizeInsuranceId(fromItem);
          return resolveBookingInsuranceId(
            responseRental.data.booking || responseRental.data
          );
        })(),
        r_insurance: (() => {
          const fromItem =
            responseRental.data.insurance &&
            responseRental.data.insurance[0] &&
            responseRental.data.insurance[0].id;
          const id =
            fromItem != null
              ? normalizeInsuranceId(fromItem)
              : resolveBookingInsuranceId(
                  responseRental.data.booking || responseRental.data
                );
          return isPaidInsurance(id);
        })(),
        low_seat: responseRental.data.seat.length > 0,
        comments: responseRental.data.comment,
        imt_commentN: responseRental.data.imt_comment,
        discount: responseRental.data.discount,
        extra_comments: responseRental.data.extra_comments,
        rental: responseRental.data,
        locations: responseLocations.data,
        models: vehicleModels.data,
        chargesRental: extraChargesPayed,
        chargeAvalaibleSuplement: suplementRemeaning,
        // chargeTypeId:
        //   this.isUserStripe() && !responseRental.data.from_agency ? "1" : "2"
      },

      async () => {
        const booking = path(['rental', 'booking'], this.state);
        const priceDate = booking.price_date;

        const [
          vehicles,
          gpsDevices,
          modelPrices1,
          modelPrices2,
          gpsPrices,
          locationFees,
          insurancePrices,
          hollidays1,
          hollidays2
        ] = await Promise.all([
          this.getVehicles(true),
          this.getGpsDevices(),
          this.getModelPrices1(priceDate),
          this.getModelPrices2(priceDate),
          this.gpsPrices(priceDate),
          this.locationFeePrices(priceDate),
          this.insurancePrices(priceDate),
          this.getHolidays1(),
          this.getHolidays2()
        ]);
        //let arrayVehicleNu = vehicles.data.push(arrayVehicle)
        let hash = {}
        let arrayVehicle = vehicles.data.filter(o => hash[o.id] ? false : hash[o.id] = true);
        this.setState({
          vehicles: arrayVehicle,
          gpsDevices: gpsDevices.data,
          modelPrices1: modelPrices1.data,
          modelPrices2: modelPrices2.data,
          gpsPrices: gpsPrices.data,
          locationFees: locationFees.data,
          insurancePrices: insurancePrices.data,
          hollidays1: hollidays1.data,
          hollidays2: hollidays2.data
        });
      }
    );

  }

  async componentDidUpdate() {
    const { id } = this.props.match.params;
    if (isNull(this.state.rental)) {
      await this.fetchData(id);
    }
  }

  async componentDidMount() {
    const { id } = this.props.match.params;
    if (isNull(this.state.rental)) {
      await this.fetchData(id);
    }
  }

  duration = (date1, time1, date2, time2) => {
    const days = moment(date2).diff(date1, "days");
    if (time1 === "10:00:00" && time2 === "18:00:00") {
      return days + 1;
    } else if (time1 === "18:00:00" && time2 === "10:00:00") {
      return days - 1;
    }
    return days || 0;
  };

  isOnSameDay = (date_1, date_2) => {
    return moment(date_1).isSame(date_2, 'day');
  };

  getModelName = modelId => {
    const { models } = this.state;
    return prop("model_name", find(propEq("id", modelId), models));
  };

  getModelName1() {
    const { models, vehicle_model_1 } = this.state;
    const selectedModel = head(filter(propEq("id", vehicle_model_1), models));
    return selectedModel.model_name;
  }

  handleCheckChangeConfirm = (event, valueToConfirm) => {
    if (this.state.partial === 0) {
      this.setState({
        [event.target.name]: event.target.checked,
        partial: valueToConfirm
      });
    }
    else {
      this.setState({
        [event.target.name]: event.target.checked,
      });
    }
  };

  handleSendEmailCheckChange = event => {
    this.setState({
      [event.target.name]: event.target.checked,
    });
  };

  handleCheckChange = event => {
    this.setState({
      [event.target.name]: event.target.checked,
      partial: 0,
      checkedF: false
    });

    if (event.target.name === "r_gps") {
      this.setState({
        gpsDeviceId: 0
      });
    }
  };

  handleChange = (element, type) => {
    this.setState({ [type]: element.target.value });
    // if (element.target.id === "date_1") {
    //   const newDate2 = moment(element.target.value).add(1, 'day').format("YYYY-MM-DD")
    //   const date2 = document.getElementById('date_2')
    //   date2.min = element.target.value
    //   date2.value = newDate2
    //   this.setState({ date_2: newDate2 })
    // }
    this.setState(
      {
        vehicleId: 0,
        gpsDeviceId: 0,
        checkedF: false,
        partial: 0
      },
      async () => {
        const booking = path(['rental', 'booking'], this.state);
        const priceDate = booking.price_date;

        const [
          updatedVehicles,
          updatedGps,
          updatedLocationFees,
          updatedHollidays1,
          updatedHollidays2
        ] = await Promise.all([
          this.getVehicles(false),
          this.getGpsDevices(),
          this.locationFeePrices(priceDate),
          this.getHolidays1(),
          this.getHolidays2()
        ]);

        const { date_1, date_2, r_insurance_id } = this.state;
        let { time_1, time_2 } = this.state;

        // If it's a rental that starts and ends on the same day force morning pickup and evening dropoff
        const sameDay = this.isOnSameDay(date_1, date_2)
        time_1 = sameDay ? "10:00:00" : time_1;
        time_2 = sameDay ? "18:00:00" : time_2;

        const promo = buildRentalPromoSnapshot({
          date_1,
          time_1,
          date_2,
          time_2,
          from_agency: path(["from_agency"], this.state.rental),
        })
        const nextInsId = resolveApplicableInsuranceId(
          r_insurance_id,
          promo.extras_days
        )

        this.setState({
          rentalDays: promo.moto_days,
          r_insurance_id: nextInsId,
          r_insurance: isPaidInsurance(nextInsId),
          vehicles: updatedVehicles.data,
          gpsDevices: updatedGps.data,
          locationFees: updatedLocationFees.data,
          hollidays1: updatedHollidays1.data,
          hollidays2: updatedHollidays2.data,
          time_1: time_1,
          time_2: time_2,
        });
      }
    );
  };

  handleSaveClick = () => {
    const { submit } = this.props;
    this.setState({ isOnSubmit: true }, () => {
      submit("process-rental");
    });
  };

  handleSubmit = async () => {
    const {
      chargeId,
      discount,
      partial,
      checkedF,
      rental,
      vehicleId,
      date_1,
      date_2,
      time_1,
      time_2,
      extra_comments,
      imt_comment,
      location_id_1,
      location_id_2,
      chargeTypeId,
      comments,
      gpsDeviceId,
      r_gps,
      r_insurance_id, low_seat,
      vehicle_model_1,
      rewards,
      refund_value,
      invoice_comments,
      noEditEmail,
      chargeAvalaibleSuplement
    } = this.state;

    let discountC = discount
    if(discount == undefined || discount == null){
      discountC = 0
    }

    const bodyRequest = {
      id: rental.id,
      data: {
        id: rental.id,
        newVehicleId: vehicleId,
        newGpsId: gpsDeviceId,
        charge_id: chargeId,
        driver_id: rental.client_id,
        partial,
        checkedF,
        discount: !isNil(discountC) ? discountC : 0,
        vehicle_id: vehicleId,
        date_1,
        date_2,
        time_1,
        time_2,
        location_id_1,
        location_id_2,
        charge_type_id: chargeTypeId,
        comments,
        imt_comment,
        extra_comments,
        invoice_comments,
        gpsdevice_id: gpsDeviceId,
        refund_value,
        r_gps: this.is1600Gt() ? true : r_gps,
        r_insurance_id: normalizeInsuranceId(r_insurance_id),
        r_insurance: isPaidInsurance(r_insurance_id),
        low_seat,
        vehicle_model_id: vehicle_model_1,
        rewards,
        noEditEmail,
        addSuplement: checkedF && chargeAvalaibleSuplement > 0 ? true : false, 
        chargeSuplement
      }
    };

    const from = this.props.location.search || null;
    const newStr = from != null ? from.substring(6) : null
    const redirect = newStr ? newStr : "rentals";

    const dataProvider = await dataProviderFactory("rest");
    dataProvider(UPDATE, "rentals", bodyRequest)
      .then(() => {
        this.setState({
          availableItems: {},
          data: {},
          events: {},
          newItem: 0
        });
        const { history } = this.props;
        history.replace(`/${redirect}`);
      })
      .catch(error => {
        this.setState({ isOnSubmit: false });
        this.props.showNotification(error.message, 'error')
      });
  };

  getStripeType(rental) {
    return rental.location_1.location_name === "Lisbon"
      ? "rentals_pt"
      : "rentals";
  }

  isUserStripe = () => {
    const { rental } = this.state;
    let stripToUse = null;
    if (!isNil(rental)) {
      const stripeType = this.getStripeType(rental);
      stripToUse = prop(`stripe_${stripeType}`, rental.driver);
    }
    return !isNil(stripToUse);
  };

  isWeekEnd = curDay => {
    const date1 = moment(curDay);
    return date1.weekday() === 6 || date1.weekday() === 0;
  };

  isHoliday = (curDay, items) => {
    const hasHollidays = [];
    map(hd => {
      const date1 = moment(hd.date).format("YYYY-MM-DD");
      const date2 = curDay.format("YYYY-MM-DD");
      if (date1 === date2 || curDay.weekday() === 6 || curDay.weekday() === 7) {
        hasHollidays.push(hd);
      }
    }, items || []);
    return length(hasHollidays) > 0;
  };

  handleChangeItem = (element, type) => {
    this.setState({ [type]: element.target.value });
  };

  handelModelChange = element => {
    // const selectedVehicle = head(this.state.rental.vehicle) || {};
    let rentalDays = this.duration(this.state.date_1, this.state.time_1, this.state.date_2, this.state.time_2);
    let model1PriceOld = this.getVehicleModelPrices(this.state.modelPrices1, rentalDays);
    const modelPrice1OldState = this.state.modelPrices1
    const modelPrice2OldState = this.state.modelPrices2
    this.setState(
      {
        vehicle_model_1: element.target.value,
        vehicles: [],
        modelPrices1: [],
        modelPrices2: [],
        vehicleId: 0,
        r_gps: this.state.r_gps || this.is1600Gt()
      },
      async () => {
        const booking = path(['rental', 'booking'], this.state);
        const priceDate = booking.price_date;
        const updatedVehicles = await this.getVehicles(true);
        const updatedModelPrices1 = await this.getModelPrices1(priceDate);
        const updatedModelPrices2 = await this.getModelPrices2(priceDate);

        //comparar precio nueva seleccion
        let model1PriceNew = this.getVehicleModelPrices(updatedModelPrices1.data, rentalDays);
        //evalua si el precio de moto disminuye
        if(model1PriceOld <= model1PriceNew)
        {
          this.setState({
            vehicles: updatedVehicles.data,
            modelPrices1: updatedModelPrices1.data,
            modelPrices2: updatedModelPrices2.data
          });
        } 
        else{
          this.setState({
            vehicles: updatedVehicles.data, 
            modelPrices1: modelPrice1OldState,
            modelPrices2: modelPrice2OldState
          });
        } 
      }
    );
  };

  is1600Gt = () => {
    return this.getModelName(this.state.vehicle_model_1) === "K1600GT";
  };

  validateDates = () => {
    const { date_1, date_2 } = this.state;
    const d2 = moment(date_2);
    const d1 = moment(date_1);
    return d2.isAfter(d1) || d1.isSame(d2, 'day');
  };

  chargeTypeId = rental => {
    const chargeTypes = [
      { _id: "1", description: "Stripe" },
      { _id: "2", description: "Other (Money, bank transfer)" }
    ];
    return (
      <div>
        <InputLabel htmlFor="charge-simple">Charge Type</InputLabel> <br />
        <StyledSelect
          onChange={e => this.handleChangeItem(e, "chargeTypeId")}
          inputProps={{
            name: "charge",
            id: "charge-simple"
          }}
          value={this.state.chargeTypeId}
          disabled={!this.isUserStripe() || rental.from_agency}
        >
          {map(item => {
            return (
              <MenuItem key={item._id} value={item._id}>
                {item.description}
              </MenuItem>
            );
          }, chargeTypes)}
        </StyledSelect>
        <br />
      </div>
    );
  };

  checkOneDay = (bike) => {
    const date2 = Date.parse(this.state.date_2); //fecha inicializada correctamente
    let nextDay = new Date(date2); // no usar bike no trae la fecha date_2
    nextDay.setDate(nextDay.getDate() + 1);

    if (nextDay.toISOString().slice(0, 10) == this.state.date_1) {
      return true
    } else {
      return false
    }
  }

  render() {
    if (isNil(this.state.rental) || isNil(this.state.vehicles)) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    const {
      rental,
      models,
      locations,
      vehicles,
      gpsDevices,
      modelPrices1,
      modelPrices2,
      date_1,
      date_2,
      time_1,
      rewards,
      time_2,
      gpsPrices,
      locationFees,
      insurancePrices,
      location_id_1,
      location_id_2,
      r_insurance_id, low_seat,
      r_gps,
      partial,
      checkedF,
      discount,
      hollidays1,
      hollidays2,
      isOnSubmit,
      chargeId, chargesRental
    } = this.state;

    const charges = prop("charges", head(rental.payments));
    const refund_value = parseInt(this.state.refund_value, 0) || 0;

    // const extraChargesValues =
    //   sum(map(prop("value"), filter(propEq("extra_charge", true), charges))) ||
    //   0;

    const totalRefunded = sum(
      map(
        prop("refunded_value"),
        filter(
          propEq("status", true),
          filter(propEq("to_refund", true), charges)
        )
      )
    );

    const totalPayed =
      sum(map(prop("value"), filter(propEq("status", true), charges))) -
      totalRefunded;

    let valueRemaining = 0;

    let model1Price = 0;
    let model2Price = 0;
    let gpsPrice = 0;
    let locationFee = 0;
    let rentalTotal1 = 0;
    let rentalTotal2 = 0;
    let vipInsurancePrice = 0;
    let maxRefundValue = 0;
    let chargesFiltered = [];
    let selectdCharge = 0;
    let availableChargeValue = 0;

    let rentalDays = this.duration(date_1, time_1, date_2, time_2);
    const promo = buildRentalPromoSnapshot({
      date_1,
      time_1,
      date_2,
      time_2,
      from_agency: path(["from_agency"], this.state.rental),
    });
    const motoDays = promo.moto_days;
    const extrasDays = promo.extras_days;

    if (rentalDays > 0 && !isNil(rentalDays)) {
      model1Price = this.getVehicleModelPrices(modelPrices1, motoDays);
      model2Price = this.getVehicleModelPrices(modelPrices2, motoDays);

      gpsPrice = r_gps
        ? prop(
          "price",
          head(
            filter(propEq("price_item_type", "gps_device"), gpsPrices)
          )
        )
        : 0;

      if (r_gps && this.is1600Gt()) {
        gpsPrice = 0;
      }

      locationFee = location_id_1 !== location_id_2 ? prop("price", head(locationFees)) : 0;

      const applicableInsId = resolveApplicableInsuranceId(
        r_insurance_id,
        extrasDays
      );
      vipInsurancePrice = dailyInsurancePriceFromList(
        insurancePrices,
        applicableInsId
      );
 
      const moto1Total = applyLowSeasonDiscountFor(model1Price * motoDays, promo, "moto");
      const moto2Total = applyLowSeasonDiscountFor(model2Price * motoDays, promo, "moto");
      const gpsTotal = applyLowSeasonDiscountFor(gpsPrice * extrasDays, promo, "gps");
      const vipTotal = applyLowSeasonDiscountFor(
        vipInsurancePrice * extrasDays,
        promo,
        "vip"
      );
      const oneWayTotal = applyLowSeasonDiscountFor(locationFee, promo, "one_way");

      rentalTotal1 =
        moto1Total +
        gpsTotal +
        vipTotal +
        oneWayTotal -
        rewards;
      // -
      // discount; // +
      // extraChargesValues;

      rentalTotal2 =
        moto2Total +
        gpsTotal +
        vipTotal +
        oneWayTotal -
        rewards;
      // -
      // discount; //-
      // rewards +
      // extraChargesValues;

      const totalRefunded = sum(
        map(
          prop("refunded_value"),
          filter(
            propEq("status", true),
            filter(propEq("to_refund", true), charges)
          )
        )
      );

      valueRemaining = rentalTotal1 - (totalPayed - chargesRental);

      maxRefundValue = Math.round(rental.rental_price, 0) - rentalTotal1;

      chargesFiltered =
        filter(
          obj =>
            obj.value.toFixed(2) - obj.refunded_value.toFixed(2) >=
            maxRefundValue.toFixed(2),
          filter(
            propEq("status", true),
            filter(obj => obj.refunded_value <= obj.value, charges)
          )
        ) || [];

      selectdCharge = head(filter(propEq("id", chargeId), chargesFiltered));

      availableChargeValue =
        prop("value", selectdCharge) - prop("refunded_value", selectdCharge) ||
        0;
    }
    let dayActual = moment(Date.now()).format("YYYY-MM-DD")

    let valueReamaningRentalPrice = parseFloat(rental.rental_price.toFixed(2)) - parseFloat(totalPayed.toFixed(2))
    let extraCharges = 0;

    let valueRemainingText = valueRemaining
    if (rental.payed) {
      if (valueReamaningRentalPrice > 0) {
        valueRemaining = valueReamaningRentalPrice
        addSuplement = true
      }
      extraCharges =
        sum(map(prop("value"),
          filter(
            propEq("status", false),
            filter(obj => obj.extra_charge = true, charges)
          )
        ));
      if (extraCharges > 0) {
        addSuplement = true
      }
    }
    else {
      extraCharges =
        sum(map(prop("value"),
          filter(
            propEq("status", false),
            filter(obj => obj.extra_charge = true, charges)
          )
        ));
      if (extraCharges > 0) {
        addSuplement = true
        chargeSuplement = extraCharges
      }
      valueRemaining = valueRemaining + extraCharges
    }

    return (
      <React.Fragment>
      <Card>
        <CardContent>
          <Typography
            gutterBottom
            variant="display3"
            component="h2"
            style={styles.cardHeaderStyle}
          >
            Processing Edit motorcycle Rental For:{" "}
            <b>
              {rental.booking.r_first_name} {rental.booking.r_last_name}
            </b>
            <ProfileCompleteMark record={rental} size={28} />
          </Typography>
          <br />
          <Responsive
            medium={
              <div>
                <div style={styles.flex}>
                  <div style={styles.leftColB}>
                    <div style={styles.flexB}>
                      <SimpleForm
                        style={{ width: "100%" }}
                        form="process-rental"
                        onSubmit={this.handleSubmit}
                        toolbar={null}
                      >
                        <InputLabel shrink={true} htmlFor="l1-simple">
                          Pick Up Location
                        </InputLabel>
                        <StyledSelect
                          onChange={e => this.handleChange(e, "location_id_1")}
                          inputProps={{
                            name: "l1",
                            id: "l1-simple"
                          }}
                          value={this.state.location_id_1}
                        /* disabled={moment(rental.date_1).diff(dayActual, "days") <= 0 ? true : false} */
                        //disabled={this.state.location_id_1 === 3}
                        >
                          {map(item => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.location_name}
                              </MenuItem>
                            );
                          }, locations)}
                        </StyledSelect>
                        <br />
                        <TextField
                          id="date_1"
                          label="Pick Up Date"
                          type="date"
                          onChange={e => this.handleChange(e, "date_1")}
                          value={this.state.date_1}
                          /* defaultValue={moment(rental.date_1).format(
                            "YYYY-MM-DD"
                          )} */
                          /* disabled={moment(rental.date_1).diff(dayActual, "days") <= 0 ? true : false} */
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                        {this.state.date_1 === "" && (
                          <StyledSpan>* Please select Pick-up date</StyledSpan>
                        )}
                        <br />
                        <InputLabel shrink={true} htmlFor="time_1-simple">
                          Pick Up Time
                        </InputLabel>
                        <StyledSelect
                          disabled={this.isOnSameDay(date_1, date_2)}
                          onChange={e => this.handleChange(e, "time_1")}
                          inputProps={{
                            name: "time_1",
                            id: "time_1-simple"
                          }}
                          value={this.state.time_1}
                        >
                          {map(
                            item => {
                              return (
                                <MenuItem value={item.id} key={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            },
                            [
                              ...RENTAL_TIME_OPTIONS
                            ]
                          )}
                        </StyledSelect>

                        <br />
                        <InputLabel shrink={true} htmlFor="l2-simple">
                          Drop Off Location
                        </InputLabel>
                        <StyledSelect
                          onChange={e => this.handleChange(e, "location_id_2")}
                          inputProps={{
                            name: "l1",
                            id: "l2-simple"
                          }}
                          value={this.state.location_id_2}
                        /* disabled={moment(rental.date_2).diff(dayActual, "days") <= 0 ? true : false} */
                        >
                          {map(item => {
                            return (
                              <MenuItem value={item.id} key={item.id}>
                                {item.location_name}
                              </MenuItem>
                            );
                          }, locations)}
                        </StyledSelect>
                        <br />
                        <TextField
                          id="date_2"
                          label="Drop-Off Date"
                          type="date"
                          onChange={e => this.handleChange(e, "date_2")}
                          defaultValue={moment.utc(rental.date_2).format(
                            "YYYY-MM-DD"
                          )}
                          InputLabelProps={{
                            shrink: true
                          }}
                        /*disabled={moment(rental.date_2).diff(dayActual, "days") < 0 ? true : false}*/
                        />

                        {this.state.date_2 === "" && (
                          <StyledSpan>* Please select Drop-off date</StyledSpan>
                        )}

                        {!this.validateDates() && (
                          <StyledSpan>
                            Drop-off date should be after Pick-up date
                          </StyledSpan>
                        )}

                        <br />
                        <InputLabel shrink={true} htmlFor="time_2-simple">
                          Drop Off Time
                        </InputLabel>
                        <StyledSelect
                          disabled={this.isOnSameDay(date_1, date_2)}
                          onChange={e => this.handleChange(e, "time_2")}
                          inputProps={{
                            name: "time_2",
                            id: "time_2-simple"
                          }}
                          value={this.state.time_2}
                        >
                          {map(
                            item => {
                              return (
                                <MenuItem value={item.id} key={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            },
                            [
                              ...RENTAL_TIME_OPTIONS
                            ]
                          )}
                        </StyledSelect>

                        <FormControlLabel
                          control={
                            <Switch
                              name="r_gps"
                              id="r_gps"
                              checked={this.state.r_gps || this.is1600Gt()}
                              onChange={e => this.handleCheckChange(e)}
                              value="0"
                              color="primary"
                              disabled={this.is1600Gt()}
                            />
                          }
                          label="GPS"
                        />
                        <br />

                        <InputLabel htmlFor="r_insurance_id">Insurance</InputLabel>
                        <StyledSelect
                          name="r_insurance_id"
                          id="r_insurance_id"
                          value={this.state.r_insurance_id}
                          onChange={e => {
                            const id = normalizeInsuranceId(e.target.value);
                            this.setState({
                              r_insurance_id: id,
                              r_insurance: isPaidInsurance(id),
                            });
                          }}
                        >
                          {insuranceSelectChoices(extrasDays).map(opt => (
                            <MenuItem
                              key={opt.id}
                              value={opt.id}
                              disabled={!!opt.disabled}
                            >
                              {opt.name}
                            </MenuItem>
                          ))}
                        </StyledSelect>
                        <FormControlLabel
                          control={
                            <Switch
                              name="low_seat"
                              id="low_seat"
                              checked={this.state.low_seat}
                              onChange={e => this.handleCheckChange(e)}
                              value="0"
                              color="primary"
                            />
                          }
                          label="Low Seat"
                        />
                        <br />
                        <Button
                          variant="outlined"
                          color="primary"
                          size="small"
                          onClick={() => this.setState({ clientDocumentsModalOpen: true })}
                          disabled={!(this.state.rental && (this.state.rental.client_id || this.state.rental.id))}
                        >
                          View / upload client documents
                        </Button>
                        <br />

                        <InputLabel shrink={true} htmlFor="model-simple">
                          Model
                        </InputLabel>
                        <StyledSelect
                          onChange={this.handelModelChange}
                          inputProps={{
                            name: "model",
                            id: "model-simple"
                          }}
                          value={this.state.vehicle_model_1}
                        >
                          {map(item => {
                            return (
                              <MenuItem value={item.id} key={item.id}>
                                {item.model_name}
                              </MenuItem>
                            );
                          }, models)}
                        </StyledSelect>

                        <br />
                        <InputLabel shrink={true} htmlFor="bike-simple">
                          Motorcycle *
                        </InputLabel>
                        <StyledSelect
                          onChange={e => this.handleChangeItem(e, "vehicleId")}
                          inputProps={{
                            name: "bike",
                            id: "bike-simple"
                          }}
                          value={this.state.vehicleId}
                        >
                          {map(item => {
                            if (item.date_2.slice(0, 10) == date_1 || this.checkOneDay(item)) {
                              return (<MenuItem value={item.id} key={item.id}>
                                /!\** {item.licence_plate} {item.renting ? "®" : ""} ({item.vehicle_color} /{" "}
                                {item.vehicle_mileage} kms) **/!\
                              </MenuItem>)
                            } else {
                              return (<MenuItem value={item.id} key={item.id}>
                                {item.licence_plate} {item.renting ? "®" : ""} ({item.vehicle_color} /{" "}
                                {item.vehicle_mileage} kms)
                              </MenuItem>)
                            }
                          }, vehicles)}
                        </StyledSelect>
                        {this.state.vehicleId === 0 && (
                          <StyledSpan>* Please select Motorcycle</StyledSpan>
                        )}

                        <br />
                        {this.state.r_gps && !this.is1600Gt() && (
                          <React.Fragment>
                            <InputLabel shrink={true} htmlFor="gps-simple">
                              Gps Device *
                            </InputLabel>{" "}
                            <br />
                            <StyledSelect
                              onChange={e =>
                                this.handleChangeItem(e, "gpsDeviceId")
                              }
                              inputProps={{
                                name: "gps",
                                id: "gps-simple"
                              }}
                              value={this.state.gpsDeviceId}
                            >
                              {map(item => {
                                return (
                                  <MenuItem value={item.id} key={item.id}>
                                    {item.model}
                                  </MenuItem>
                                );
                              }, gpsDevices)}
                            </StyledSelect>
                            {this.state.gpsDeviceId === 0 &&
                              this.state.r_gps && (
                                <StyledSpan>
                                  * Please select GPS device
                                </StyledSpan>
                              )}
                          </React.Fragment>
                        )}

                        <br />
                        <TextField
                          id="discount"
                          label="Discount"
                          type="number"
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onChange={e => this.handleChangeItem(e, "discount")}
                          defaultValue={this.state.discount}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                        <div style={styles.widthFull}>
                          <div style={styles.flex}>
                            <div style={styles.leftColB}>
                              <div style={styles.flex}>
                                {valueRemaining.toFixed(2) - discount < 0 && (
                                  <StyledSpan>* Discount cannot be greater than the rental cost</StyledSpan>
                                )}

                                {valueRemaining.toFixed(2) - discount >= 0 &&
                                  /* moment(rental.date_1).diff(dayActual, "days") < 30 &&*/
                                  (
                                    <React.Fragment>
                                      <p>
                                        <InputLabel shrink={true} htmlFor="partial-simple">
                                          Partial Value to Pay <span style={styles.colorBlack}>€ {(valueRemaining - this.state.discount).toFixed(2)}</span>
                                        </InputLabel>{" "}

                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              name="checkedF"
                                              checked={this.state.checkedF}
                                              onChange={e =>
                                                this.handleCheckChangeConfirm(
                                                  e,
                                                  valueRemaining.toFixed(2) - discount >
                                                    0
                                                    ? valueRemaining.toFixed(2) -
                                                    discount
                                                    : 0
                                                )
                                              }
                                              value="checkedF"
                                            />
                                          }
                                          label="Confirm value to charge!"
                                        />
                                      </p>
                                    </React.Fragment>
                                  )}
                              </div>
                            </div>
                            <div style={styles.rightColCenterV}>
                              <div style={styles.flexCenterV}>
                                <React.Fragment>
                                  <AddSuplementCharge rental={rental} extraCharge={true} />
                                </React.Fragment>
                              </div>
                            </div>
                          </div>
                        </div>
                        <React.Fragment>
                          <div>
                            {valueRemaining - discount > 0 && (
                              <h4>
                                Total value to charge:{" "}
                                {Math.abs(valueRemainingText - discount).toFixed(2)}{" "}
                                €
                              </h4>
                            )}
                            {extraCharges > 0 && (
                              <h4>
                                Supplement value to charge:{" "}
                                {Math.abs(extraCharges).toFixed(2)}{" "}
                                €
                              </h4>
                            )}

                            {moment(rental.date_1).diff(dayActual, "days") <
                              30 && (
                                <p>{moment(rental.date_1).diff(dayActual, "days")} days left to rental date.</p>
                              )}
                            <br />
                            {this.chargeTypeId(rental)}
                          </div>
                        </React.Fragment>
                        <br />
                        <TextField
                          fullWidth
                          id="invoice_comments"
                          label="Invoice Comments"
                          type="text"
                          onChange={e =>
                            this.handleChangeItem(e, "invoice_comments")
                          }
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                        <br />
                        <br />
                        <TextField
                          fullWidth
                          id="imt_comment"
                          label="IMT Comments (if charge type not Stripe)"
                          type="text"
                          onChange={e =>
                            this.handleChangeItem(e, "imt_comment")
                          }
                          //defaultValue={this.state.imt_comment}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                        <br />
                        <React.Fragment>
                          <span style={{ backgroundColor: 'yellow' }}>IMT previous comments: {this.state.imt_commentN}</span>
                        </React.Fragment>
                        <br />

                        <br />
                        <TextField
                          fullWidth
                          id="extra_comments"
                          label="Internal Comments"
                          type="text"
                          onChange={e =>
                            this.handleChangeItem(e, "extra_comments")
                          }
                          defaultValue={this.state.extra_comments}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      </SimpleForm>
                    </div>

                    <CardContent>
                      <Grid container spacing={16} direction="column">
                        <Grid item>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="noEditEmail"
                                checked={this.state.noEditEmail}
                                onChange={e => this.handleSendEmailCheckChange(e)}
                                value="noEditEmail"
                              />
                            }
                            label="Don't send edit e-mail"
                          />
                        </Grid>
                        <Grid item>
                          <div>
                            <div style={styles.flex}>
                              <div style={styles.leftColB}>
                                <div style={styles.flex}>
                                  <SaveButton
                                    onClick={this.handleSaveClick}
                                    disabled={
                                      // isOnSubmit ||
                                      // (rentalTotal1 < rental.rental_price &&
                                      //   refund_value > 0) ||
                                      (rentalTotal1 < rental.rental_price &&
                                        refund_value > maxRefundValue) ||
                                      // (refund_value > availableChargeValue &&
                                      //  rentalTotal1 < rental.rental_price) ||
                                      // (this.state.chargeId === 0 &&
                                      //  rentalTotal1 < rental.rental_price) ||
                                      this.state.partial < 0 && !this.state.checkedF ||
                                      this.state.date_2 === "" ||
                                      this.state.date_1 === "" ||
                                      this.state.vehicleId === 0 ||
                                      !this.validateDates() ||
                                      (this.state.gpsDeviceId === 0 && this.state.r_gps && !this.is1600Gt())
                                    }
                                    saving={isOnSubmit}
                                  />
                                </div>
                              </div>
                              <div style={styles.rightCol}>
                                <div style={styles.flex}>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </div>
                  <div style={styles.rightCol}>
                    <div style={styles.flex}>
                      <Card>
                        <CardContent>
                          <Paper>
                            <SimpleForm toolbar={null}>
                              <InputLabel
                                shrink={true}
                                style={{ textAlign: "center" }}
                              >
                                Choices & Prices
                              </InputLabel>
                              <FunctionField
                                label="Booking Date"
                                render={() => {
                                  return moment.utc(
                                    rental.booking.r_timestamp
                                  ).format(DATEFORMAT + " HH:mm:ss");
                                }}
                              />
                              {rental.from_agency && (
                                <FunctionField
                                  label="Agency Name"
                                  render={() => {
                                    return rental.booking.agency_name;
                                  }}
                                />
                              )}
                              {rental.from_agency && (
                                <FunctionField
                                  label="Agency Contact"
                                  render={() => {
                                    return rental.booking.agency_contact;
                                  }}
                                />
                              )}
                              <FunctionField
                                label="Pick-up"
                                render={() => {
                                  let date1 = `${moment.utc(date_1).format(
                                    "DD, dddd, MMM YYYY"
                                  )}`;
                                  if (
                                    this.isHoliday(
                                      moment(date_1),
                                      hollidays1
                                    ) ||
                                    this.isWeekEnd(date_1)
                                  ) {
                                    return (
                                      <div>
                                        {date1}
                                        <span
                                          style={{
                                            color: "red",
                                            fontSize: "17px"
                                          }}
                                        >
                                          &nbsp;<b>!</b>
                                        </span>
                                      </div>
                                    );
                                  }
                                  return date1;
                                }}
                              />
                              <FunctionField
                                label="Drop-off"
                                render={() => {
                                  let date2 = `${moment.utc(date_2).format(
                                    "DD, dddd, MMM YYYY"
                                  )}`;
                                  if (
                                    this.isHoliday(
                                      moment(date_2),
                                      hollidays2
                                    ) ||
                                    this.isWeekEnd(date_2)
                                  ) {
                                    return (
                                      <div>
                                        {date2}
                                        <span
                                          style={{
                                            color: "red",
                                            fontSize: "17px"
                                          }}
                                        >
                                          &nbsp;<b>!</b>
                                        </span>
                                      </div>
                                    );
                                  }
                                  return date2;
                                }}
                                y
                              />
                              <FunctionField
                                label="Rental Duration"
                                render={() => {
                                  const occ = promo.occupancy_days > 0 ? promo.occupancy_days : 0;
                                  const billable = motoDays > 0 ? motoDays : 0;
                                  const daysLabel = promo.is_weekend
                                    ? `${occ} days · Billable: ${billable} days`
                                    : `${billable} days`;
                                  return (
                                    <span>
                                      {daysLabel}
                                      <RentalPromoBadges promo={promo} />
                                    </span>
                                  );
                                }}
                              />

                              <FunctionField
                                label="Gps"
                                render={() => {
                                  const gpsTotal = applyLowSeasonDiscountFor(
                                    gpsPrice * extrasDays,
                                    promo,
                                    "gps"
                                  );
                                  const gpsDaily =
                                    extrasDays > 0
                                      ? Math.round((gpsTotal / extrasDays) * 100) / 100
                                      : gpsPrice;
                                  return `${gpsTotal} Euros (${gpsDaily} Euros/day)`;
                                }}
                              />
                           {extraCharges > 0 && (
                                <FunctionField
                                  label=" Supplement Total"
                                  render={() => {
                                    return `${parseFloat(Math.abs(extraCharges)).toFixed(2)}`;
                                  }}
                                />
                              )}
                              
                              <FunctionField
                                label={`${insuranceLabel(this.state.r_insurance_id)} Insurance`}
                                render={() => {
                                  return `${extrasDays *
                                    vipInsurancePrice} Euros (${vipInsurancePrice} Euros/day)`;
                                }}
                              />

                              <FunctionField
                                label="One Way rental"
                                render={() => {
                                  if (
                                    this.state.location_id_1 ===
                                    this.state.location_id_2
                                  ) {
                                    return "No";
                                  }
                                  return `Yes (${locationFee} Euros)`;
                                }}
                              />
                              <FunctionField
                                label="Rewards Used"
                                render={() => {
                                  return `${rental.booking.rewards} points`;
                                }}
                              />
                              <FunctionField
                                label="First Choice Motorcycle"
                                render={() => {
                                  return this.getModelName(
                                    rental.booking.vehicle_model_1
                                  );
                                }}
                              />
                              <FunctionField
                                label="Second Choice Motorcycle"
                                render={() => {
                                  return this.getModelName(
                                    rental.booking.vehicle_model_2
                                  );
                                }}
                              />
                              <FunctionField
                                label="Daily rate for first choice motorcycle"
                                render={() => {
                                  return `${model1Price} Euros/day`;
                                }}
                              />
                              <FunctionField
                                label="Daily rate for second choice motorcycle"
                                render={() => {
                                  return `${model2Price} Euros/day`;
                                }}
                              />
                              <FunctionField
                                label="First choice of motorcycle"
                                render={() => {
                                  return `${rentalTotal1} Euros`;
                                }}
                              />
                              <FunctionField
                                label="Second choice of motorcycle"
                                render={() => {
                                  return `${rentalTotal2} Euros`;
                                }}
                              />
                              <FunctionField
                                label="Comments"
                                render={() => {
                                  return rental.booking.r_comments;
                                }}
                              />
                              <FunctionField
                                label="Allergy/Special Diet"
                                render={() => {
                                  return rental.booking.r_allergy_special_diet || "";
                                }}
                              />

                              <FunctionField
                                label="Client Passport"
                                render={() => {
                                  const passport = rental.booking && Number(rental.booking.is_for) === 2
                                    ? rental.booking.r_passport
                                    : rental.driver.passport;
                                  return `${isNil(passport) ? "N/A" : passport}`;
                                }}
                              />

                              <FunctionField
                                label="Driving Licence"
                                render={() => {
                                  const licence = rental.booking && Number(rental.booking.is_for) === 2
                                    ? rental.booking.r_license
                                    : rental.driver.driving_licence;
                                  return `${isNil(licence) ? "N/A" : licence}`;
                                }}
                              />

                              <FunctionField
                                label="Card Data"
                                render={() => {
                                  return `${isNil(rental.clientData)
                                    ? "N/A"
                                    : rental.clientData
                                    }`;
                                }}
                              />
                            </SimpleForm>
                          </Paper>
                          <ChargesGrid
                            rental={rental}
                            charges={charges}
                            reloadData={e => this.fetchData(e, this)}
                            estados={this.state}
                          />
                        </CardContent>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            }
          />
        </CardContent>
      </Card>
      <ClientDocumentsModal
        open={this.state.clientDocumentsModalOpen}
        onClose={() => this.setState({ clientDocumentsModalOpen: false })}
        clientId={documentTarget(this.state.rental).clientId}
        rentalId={documentTarget(this.state.rental).rentalId}
      />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  state: state
});

const mapDispatchToProps = {
  change,
  showNotification,
  submit
};

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(ProcessRentalEdit)
);



// WEBPACK FOOTER //
// ./src/components/processRentalEdit.js